import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Progress } from "reactstrap";

const gb = (v) => (v / 1e9).toFixed(1);
const mb = (v) => (v / 1e6).toFixed(1);

const color = (p) => {
    if (p < 60) return "success";
    if (p < 85) return "warning";
    return "danger";
};

const ServerHealth = () => {
    const [sys, setSys] = useState(null);

    const fetchSystem = async () => {
        const res = await fetch("/api/logs/storage");
        const data = await res.json();
        setSys(data);
    };

    useEffect(() => {
        fetchSystem();
        const i = setInterval(fetchSystem, 1000); //1s
        return () => clearInterval(i);
    }, []);

    if (
        !sys ||
        !sys.storage ||
        !sys.ram ||
        !sys.cpu ||
        !sys.system
    ) {
        return <p>Chargement des métriques serveur…</p>;
    }

    return (
        <Row className="mt-4">
            {/* STORAGE */}
            <Col lg={2}>
                <Card>
                    <CardBody>
                        <h5>💾 Stockage</h5>
                        <Progress value={sys.storage.percent} color={color(sys.storage.percent)} />
                        <small>
                            {gb(sys.storage.used)} / {gb(sys.storage.size)} GB ({sys.storage.percent}%)
                        </small>
                    </CardBody>
                </Card>
            </Col>

            {/* RAM */}
            <Col lg={2}>
                <Card>
                    <CardBody>
                        <h5>🧠 RAM</h5>
                        <Progress value={sys.ram.percent} color={color(sys.ram.percent)} />
                        <small>
                            {gb(sys.ram.used)} / {gb(sys.ram.total)} GB
                            {sys.ram.swapUsed > 0 && ` • Swap: ${gb(sys.ram.swapUsed)} GB`}
                        </small>
                    </CardBody>
                </Card>
            </Col>

            {/* CPU */}
            <Col lg={2}>
                <Card>
                    <CardBody>
                        <h5>⚙️ CPU</h5>
                        <Progress value={sys.cpu.load} color={color(sys.cpu.load)} />
                        <small>
                            {sys.cpu.load}% • {sys.cpu.cores} cœurs
                            {sys.cpu.temperature && ` • ${sys.cpu.temperature}°C`}
                        </small>
                    </CardBody>
                </Card>
            </Col>

            {/* NETWORK */}
            <Col lg={3}>
                <Card>
                    <CardBody>
                        <h5>🌐 Réseau</h5>
                        <small>
                            ⬇️ RX : {mb(sys.network.rx)} MB
                            <br />
                            ⬆️ TX : {mb(sys.network.tx)} MB
                        </small>
                    </CardBody>
                </Card>
            </Col>

            {/* SYSTEM */}
            <Col lg={3}>
                <Card>
                    <CardBody>
                        <h5>🖥️ Système</h5>
                        <small>
                            OS : {sys.system.os}
                            {/*<br />
                            Host : {sys.system.hostname}*/}
                            <br />
                            Uptime : {Math.floor(sys.system.uptime / 3600)}h
                        </small>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default ServerHealth;
